module.exports = __webpack_public_path__ + "static/media/history-01.05d4396a.jpg";